import React from 'react';

const AGGridLoader = () => {
  return <div>Loading...</div>;
};

export default AGGridLoader;
